import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { sanitize } from '../../utils/sanitizeHtml';
import { useTranslation } from "react-i18next";
import { dbLabel } from "../../i18n/dbLabels";
import user from "../../assets/images/user-pic.png"
import bookmark from "../../assets/images/icon-bookmark.png"
import editicon from "../../assets/images/edit-icon.png"
import homepng from './home-page-img.png';


const safeDOMAccess = (callback) => {
    try {
        return callback();
    } catch (error) {
        console.error('🚨 DOM access error:', error);
        return null;
    }
};

import { app } from "@microsoft/teams-js";
import Swipper from "../swipper/Swipper"
import { getkeyWordsApi, getProfilePicApi, filterAllblogs1, filterAllblogs, removeBookMarkApi, getCategoryApi, updateProfilePicApi, getUserBookMarkListApi, postSaveKeywordsApi, userBookMarkApi, getSavedKeywordsApi, deleteKeywordsApi, policies, welcomeBackApi } from "../../apis/WebServices";
import useVideos from "../../hooks/useVideos";
import VideoCatalogue from "../../services/VideoCatalogue";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import { imageEndPoint, newImageEndPoint } from "../../apis/env";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loader from "../loader/Loader";
import { Link } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext"
import { message } from "antd";
import CardSkeleton from "../Skeleton";

// Import shared professional skeleton system
import { SkeletonVideoCard, SkeletonBlogCard, SkeletonCarouselVideoCard } from "../skeletons";

import HomeBlogCarousel from "../swipper/HomeBlogCarousel";
// CRITICAL FIX: Import CSS overrides for accordion arrows
import '../../styles/accordion-arrow-fix.css';
import oopsimg from "../../assets/oops-img.png"
import Footer from "../footer/Footer";
import { videoDeepLink, blogDeepLink, blogLibraryDeepLink } from "../../apis/env";
import leftImg from "./left.png";
import rightImg from "./right.png";




const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const debounceTimer = useRef(null);
    const debounceTimeout = useRef(null);
    
    // 🔧 CRITICAL FIX: Get userToken FIRST before any other hooks that need it
    const { userName, setUserName, userToken } = useContext(UserContext);

    // 🔧 CRITICAL FIX: Declare ALL state variables used in useVideos hooks BEFORE the hooks
    const [selectedCatgId, setSelectCatgId] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [keyIds, setKeyIds] = useState([]);

    const [searchInput, setSearchInput] = useState("");
    const [keywords, setKeyWords] = useState("")

    const [searchKeyword, setSearchKeyword] = useState("");
    // 🔧 FIXED: Now userToken is available for initialization
    const { 
        data: categoryVideoData, 
        loading: categoryLoading, 
        fetchData: fetchCategoryVideos 
    } = useVideos('category', {
        userId: userToken, // Don't provide fallback - wait for actual token
        categoryId: selectedCatgId,
        keywordIds: keyIds,
        searchName: searchValue,
        pageSize: 1000,
        pageNumber: 1
    }, false); // 🔧 CRITICAL: autoFetch=false prevents immediate execution
    
    const { 
        data: listVideoData, 
        loading: listLoading, 
        fetchData: fetchListVideos 
    } = useVideos('list', {
        userId: userToken, // Don't provide fallback - wait for actual token
        categoryId: selectedCatgId,
        keywordIds: keyIds,
        searchName: searchValue,
        pageSize: 1000,
        pageNumber: 1
    }, false); // 🔧 CRITICAL: autoFetch=false prevents immediate execution
    
    const [videos, setVideos] = useState({})
    const [getAllVideos, setGetAllVideos] = useState([]);
    const [allCategory, setAllCategroy] = useState('');
    const [disableAllCategory, setDisableAllCategory] = useState(false)
    const [showCategories, setShowCategories] = useState(false)
    const [showModel, setShowModel] = useState(false);
    const [searchdebounce, setSearchDebounce] = useState('')
    const [loading, setLoading] = useState(true);

    const [swipping, setSwipping] = useState(1)
    const [activeAccordions, setActiveAccordions] = useState([]);

    const [savedKeywords, setSaveKeywords] = useState([])
    const [showSkeleton, setShowSkeleton] = useState(false);

    const [activeDurationAccordions, setActiveDurationAccordions] = useState([]);
    const [previousData, setPreviousData] = useState([]);
    const [profilePic, setProfilePic] = useState('');

    const [loader, setLoader] = useState(false)
    const [resetModal, setResetModal] = useState(false);
    const [bottomList, setBottomList] = useState([]);
    const [initial, setInitial] = useState(true);
    // State management
    const [BookMarkedTrueIds, setAllBookMarkedTrueIds] = useState([]);
    // FIXED: Add ref to prevent duplicate bookmark API calls
    const isLoadingBookmarks = useRef(false);
    const [filterBlogs, setFilterAllblogs] = useState([]);
    const [noBlog, setNoBlog] = useState(false)
    const [blogFetchError, setBlogFetchError] = useState(false)
    const [filteredVideos, setFilteredVideos] = useState('');
    const [videoFetchError, setVideoFetchError] = useState(false);

    // FIXED: Initialize as empty so NO sections are expanded by default
    const [activeSubcategories, setActiveSubcategories] = useState({});
    // State for managing blog accordion sections
    const [activeBlogAccordions, setActiveBlogAccordions] = useState([]);
    const [title, setTitle] = useState(null);
    const [userVisitCount, setUserVisitCount] = useState(0);
    const [bookMarkedStatus, setBookMarkedStatus] = useState(false);
    const [bookmarkLoadingIds, setBookmarkLoadingIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingRequests, setLoadingRequests] = useState(new Set());
    const [profileImage, setProfileImage] = useState('');
    
    // Prevent duplicate API calls
    const makeUniqueRequest = async (requestKey, apiCall) => {
        if (loadingRequests.has(requestKey)) {
            console.log(`🔄 Skipping duplicate request: ${requestKey}`);
            return;
        }
        
        setLoadingRequests(prev => new Set(prev).add(requestKey));
        try {
            await apiCall();
        } finally {
            setLoadingRequests(prev => {
                const newSet = new Set(prev);
                newSet.delete(requestKey);
                return newSet;
            });
        }
    };


    const fetchHomeContent = async () => {

        try {
            const response = await policies();
            if (response?.isSuccess) {
                const filter = response?.data?.filter((item) => item?.type === "Home");

                setTitle(filter);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }


    const toggleSubcategory = (category, subcategory) => {
        setActiveSubcategories((prev) => ({
            ...prev,
            [category]: prev[category] === subcategory ? null : subcategory,
        }));
        
        // CRITICAL FIX: Force carousel recalculation after height change
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            if (window.jQuery && window.jQuery('.owl-carousel').length) {
                window.jQuery('.owl-carousel').trigger('refresh.owl.carousel');
            }
        }, 300);
    };

    const fetchAllBlogs = async () => {
        try {
            setFilterAllblogs("")
            setNoBlog(false)
            setBlogFetchError(false)

            const response = await filterAllblogs({ userId: userToken, selectedCatgId, keyIds, searchValue, pageNumber: 1, pageSize: 1000 });
            if (response?.isSuccess) {
                setNoBlog(false)
                setBlogFetchError(false)
                setFilterAllblogs(response)
            }
            else {
                setNoBlog(true)
                setBlogFetchError(false)
            }
        } catch (error) {
            console.error('Error fetching blogs:', error);
            setBlogFetchError(true)
            setNoBlog(true)
        }
    }



    const fetchAllBlogs1 = async (keyIds) => {
        try {
            setNoBlog(false)
            setBlogFetchError(false)
            setFilterAllblogs("")
            const response = await filterAllblogs1({ userId: userToken, selectedCatgId, keyIds, searchValue, pageNumber: 1, pageSize: 1000 });
            if (response?.isSuccess) {
                setFilterAllblogs(response)
            }
            else {
                setNoBlog(true)
                setBlogFetchError(false)
            }
        } catch (error) {
            console.error('Error fetching blogs:', error);
            setBlogFetchError(true)
            setNoBlog(true)
        }
    }




    const filterKeywords = () => {

        const query = searchKeyword.trim().toLowerCase();
        if (!query) return keywords;

        for (const key in keywords) {
            if (query.startsWith(key.toLowerCase())) {
                if (query.length === 1) {
                    return { [key]: keywords[key] };
                }
                const filteredItems = keywords[key].filter(item =>
                    item.name.toLowerCase().includes(query)
                );

                return filteredItems.length > 0 ? { [key]: filteredItems } : {};
            }
        }

        return {};
    };


    const searchingFilter = filterKeywords()


    const handleSearch = (e) => {
        setSearchKeyword(e.target.value);
    }


    const fetchAllCategories = async () => {
        try {
            const response = await getCategoryApi();
            if (response?.isSuccess) {
                setAllCategroy(response)
            }


        } catch (error) {

        }
    }

    // Process category videos when data changes
    useEffect(() => {
        if (categoryVideoData?.categoryWise) {
            setVideos({
                data: categoryVideoData,
                isSuccess: true
            });
            
            // Process subcategory-wise videos using clean service
            const subCategorywiseVideos = VideoCatalogue.processSubCategoryVideos(categoryVideoData.categoryWise);
            setFilteredVideos(subCategorywiseVideos);
        }
    }, [categoryVideoData]);
    
    // Process list videos when data changes
    useEffect(() => {
        if (listVideoData?.videos) {
            setGetAllVideos({
                data: { videos: listVideoData.videos },
                isSuccess: true
            });
            
            // FIXED: Only fetch bookmarks once when we get video data
            if (BookMarkedTrueIds.length === 0 && !isLoadingBookmarks.current) {
                fetchBookmarkedVideoIds();
            }
        }
    }, [listVideoData]);
    
    // FIXED: Dedicated function to fetch bookmarked video IDs with duplicate call prevention
    const fetchBookmarkedVideoIds = useCallback(async () => {
        // Prevent duplicate calls
        if (isLoadingBookmarks.current) {
            return;
        }
        
        try {
            if (!userToken || userToken === 'undefined') {
                return;
            }
            
            isLoadingBookmarks.current = true;
            
            const response = await getUserBookMarkListApi(1, 1000, userToken);
            
            if (response?.isSuccess) {
                // CRITICAL FIX: Backend returns { data: { videos: [...] } }
                let bookmarkData = response.data?.videos || response.data;
                
                // If data is not an array, try to find the array in the response
                if (!Array.isArray(bookmarkData)) {
                    bookmarkData = response.result?.videos || response.items || response.bookmarks || [];
                }
                
                if (Array.isArray(bookmarkData)) {
                    const bookmarkedIds = bookmarkData.map(item => item.id || item.videoId).filter(id => id);
                    setAllBookMarkedTrueIds(bookmarkedIds);
                } else {
                    setAllBookMarkedTrueIds([]);
                }
            } else {
                setAllBookMarkedTrueIds([]);
            }
        } catch (error) {
            setAllBookMarkedTrueIds([]);
        } finally {
            isLoadingBookmarks.current = false;
        }
    }, [userToken]);
    
    // 🔧 CRITICAL FIX: Cross-component bookmark synchronization (stable)
    useEffect(() => {
        const handleBookmarkSync = (event) => {
            // Only refresh if not already loading to prevent infinite loops
            if (!isLoadingBookmarks.current) {
                fetchBookmarkedVideoIds();
            }
        };
        
        window.addEventListener('bookmarkChanged', handleBookmarkSync);
        return () => window.removeEventListener('bookmarkChanged', handleBookmarkSync);
    }, []); // FIXED: Empty deps to prevent re-registration

    // Fetch videos with interests
    const fetchVideosWithInterests = useCallback(async (keywordIds) => {
        await Promise.all([
            fetchCategoryVideos(),
            fetchListVideos()
        ]);
    }, [fetchCategoryVideos, fetchListVideos]);




    const toggleDurationAccordion = (duration) => {
        setActiveDurationAccordions((prev) =>
            prev.includes(duration)
                ? prev.filter((item) => item !== duration)
                : [...prev, duration]
        );
        
        // CRITICAL FIX: Force carousel recalculation after height change
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            if (window.jQuery && window.jQuery('.owl-carousel').length) {
                window.jQuery('.owl-carousel').trigger('refresh.owl.carousel');
            }
        }, 300);
    };

    const toggleAccordion = (category) => {
        setActiveAccordions((prev) =>
            prev.includes(category)
                ? prev.filter((item) => item !== category)
                : [...prev, category]
        );
        
        // CRITICAL FIX: Force carousel recalculation after accordion height change
        setTimeout(() => {
            // Trigger window resize event to force carousel recalculation
            window.dispatchEvent(new Event('resize'));
            
            // Force refresh all OwlCarousel instances
            if (window.jQuery && window.jQuery('.owl-carousel').length) {
                window.jQuery('.owl-carousel').trigger('refresh.owl.carousel');
            }
        }, 300);
    };

    const toggleBlogAccordion = (category) => {
        setActiveBlogAccordions((prev) =>
            prev.includes(category)
                ? prev.filter((item) => item !== category)
                : [...prev, category]
        );
        
        // CRITICAL FIX: Force carousel recalculation after accordion height change
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            if (window.jQuery && window.jQuery('.owl-carousel').length) {
                window.jQuery('.owl-carousel').trigger('refresh.owl.carousel');
            }
        }, 300);
    };

    const handleSetSwipping = (val) => {
        setSwipping(val)

    }


    // Fetch videos without interests
    const fetchVideosWithoutInterests = useCallback(async () => {
        await Promise.all([
            fetchCategoryVideos(),
            fetchListVideos()
        ]);
    }, [fetchCategoryVideos, fetchListVideos]);

    const handleSearch1 = (e) => {
        setSearchInput(e.target.value);
    };

    useEffect(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            setSearchValue(searchInput); // even if it's empty!
        }, 500);

        return () => clearTimeout(debounceTimeout.current);
    }, [searchInput]);

    const handleKeyDown = (e) => {
        const isEnter = e.key === "Enter";
        const isDelete = e.key === "Delete";
        const isBackspace = e.key === "Backspace";

        const input = e.target;

        const isAllSelected = input.selectionStart === 0 && input.selectionEnd === input.value.length;

        if (isEnter) {
            e.preventDefault();
        }

        if ((isDelete || isBackspace) && isAllSelected) {
            e.preventDefault();
        }
    };

    const fetchProfilePic = async (userId) => {
        try {
            // Only fetch if userId is valid
            if (!userId || userId === 'undefined' || userId === 'null') {
                console.log('⚠️ fetchProfilePic skipped - invalid userId:', userId);
                return;
            }

            console.log('📸 Fetching profile pic for userId:', userId);
            const response = await getProfilePicApi(userId);
            if (response?.isSuccess) {
                setProfilePic(response?.data?.path);
                console.log('✅ Profile pic loaded successfully');
            }

        } catch (error) {
            console.error('❌ Error fetching profile pic:', error);
        } finally {

        }
    }

    const handleFileChange = async (e) => {
        console.log('🖼️ Profile upload: File change triggered');
        const file = e.target.files[0];
        console.log('📁 Selected file:', file);
        
        if (!file) {
            console.log('❌ No file selected');
            return;
        }
        
        console.log('📋 File details:', {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
        });
        
        // File type validation
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
            console.log('❌ Invalid file type:', file.type);
            message.error(t('home.uploadInvalidType'));
            return;
        }
        
        // File size validation (5MB max)
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
            console.log('❌ File too large:', file.size);
            message.error(t('home.uploadTooLarge'));
            return;
        }
        
        console.log('✅ File validation passed');
        
        const previewURL = URL.createObjectURL(file);
        setProfileImage(previewURL);
        setLoader(true)
        
        try {
            console.log('📤 Uploading profile pic with userToken:', userToken);
            const response = await updateProfilePicApi(file, userToken);
            console.log('📥 Upload response:', response);
            
            if (response?.isSuccess) {
                console.log('✅ Upload successful, new profile URL:', response?.data);
                // Set the new profile picture immediately
                if (response?.data) {
                    setProfilePic(response.data);
                }
                // Also fetch to ensure consistency
                fetchProfilePic(userToken)
                message.success(response?.message)
                setResetModal(true);
            } else {
                console.log('❌ Upload failed:', response?.message);
                setResetModal(true);
                message.error(response?.message || t('home.uploadFailed'))
            }
        } catch (error) {
            console.error('💥 Upload error:', error);
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        }
        finally {
            setResetModal(true)
            setLoader(false)
        }
    };



    const handleAddBookMark = async (id) => {
        try {
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            
            console.log('🏠 Home: Bookmark operation started', { videoId: id, isCurrentlyBookmarked: BookMarkedTrueIds.includes(id) });
            
            // CRITICAL FIX: Prevent multiple clicks during operation
            if (bookmarkLoadingIds.includes(id)) {
                console.log('⚠️ Home: Bookmark operation already in progress for video:', id);
                return;
            }
            
            setBookmarkLoadingIds(prev => [...prev, id]);
            
            const isCurrentlyBookmarked = BookMarkedTrueIds.includes(id);
            
            // CRITICAL FIX: Update UI immediately for instant feedback
            if (isCurrentlyBookmarked) {
                setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
            } else {
                setAllBookMarkedTrueIds(prev => [...prev, id]);
            }
            
            if (isCurrentlyBookmarked) {
                console.log('🗑️ Home: Removing bookmark for video:', id);
                const response = await removeBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message || 'Bookmark removed successfully');
                    console.log('✅ Home: Bookmark removed successfully');
                    // Refresh from API to ensure consistency
                    setTimeout(() => fetchBookmarkedVideoIds(), 500);
                    // 🔧 CRITICAL FIX: Notify other components
                    window.dispatchEvent(new CustomEvent('bookmarkChanged', { 
                        detail: { videoId: id, action: 'remove', component: 'Home' } 
                    }));
                } else {
                    // REVERT UI change if API failed
                    setAllBookMarkedTrueIds(prev => [...prev, id]);
                    message.error(response?.message || 'Failed to remove bookmark');
                }
            } else {
                console.log('➕ Home: Adding bookmark for video:', id);
                const response = await userBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message || 'Bookmark added successfully');
                    console.log('✅ Home: Bookmark added successfully');
                    // Refresh from API to ensure consistency
                    setTimeout(() => fetchBookmarkedVideoIds(), 500);
                    // 🔧 CRITICAL FIX: Notify other components
                    window.dispatchEvent(new CustomEvent('bookmarkChanged', { 
                        detail: { videoId: id, action: 'add', component: 'Home' } 
                    }));
                } else {
                    // REVERT UI change if API failed
                    setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
                    message.error(response?.message || 'Failed to add bookmark');
                }
            }
        } catch (error) {
            console.error('❌ Home: Bookmark operation failed:', error);
            // REVERT UI change if error occurred
            if (BookMarkedTrueIds.includes(id)) {
                setAllBookMarkedTrueIds(prev => prev.filter(itemId => itemId !== id));
            } else {
                setAllBookMarkedTrueIds(prev => [...prev, id]);
            }
            message.error(error?.message || 'Bookmark operation failed');
        } finally {
            setBookmarkLoadingIds(prev => prev.filter(itemId => itemId !== id));
        }
    };

    const handleVideoClick = (data) => {
        const videoId = data?.id;
        const categoryId = data?.categoryId || data?.category?.id;

        console.log('🎬 VIDEO CLICK: Home -> Video Catalogue tab (cross-tab navigation)');
        console.log('📍 Navigation data:', { videoId, categoryId, data });
        
        if (!videoId || !categoryId) {
            console.error('❌ Home: Missing required data for video navigation:', { videoId, categoryId });
            return;
        }
        
        console.log('📍 Navigation: Home tab -> Video Catalogue tab -> Video detail view');
        
        try {
            if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                // Teams SDK v2 method - navigate to Video Catalogue tab with video details
                const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                const subPageId = `videoId=${videoId}&vId=${categoryId}`;
                
                console.log('🚀 TEAMS NAVIGATION: Starting navigation with params:', {
                    teamsAppId,
                    pageId: 'cdf6e4d2-dfd2-4578-93e3-cdde31670154',
                    subPageId
                });
                
                // 🔍 DEBUG: Check Teams context before navigation
                window.microsoftTeams.app.getContext().then(context => {
                    console.log('🔍 TEAMS CONTEXT BEFORE NAVIGATION:', {
                        currentTab: context.page?.id,
                        currentSubPageId: context.page?.subPageId,
                        frameContext: context.page?.frameContext
                    });
                });
                
                const navPromise = window.microsoftTeams.pages.navigateToApp({
                    appId: teamsAppId,
                    pageId: 'cdf6e4d2-dfd2-4578-93e3-cdde31670154', // CORRECT Video Catalogue entity ID from manifest
                    subPageId: subPageId
                });
                
                navPromise.then(() => {
                    console.log('✅ Teams SDK says navigation successful');
                    console.log('📍 Expected: Video Catalogue should load video detail for videoId:', videoId);
                    
                    // 🔍 DEBUG: Check context after navigation
                    setTimeout(() => {
                        window.microsoftTeams.app.getContext().then(context => {
                            console.log('🔍 TEAMS CONTEXT AFTER NAVIGATION:', {
                                currentTab: context.page?.id,
                                currentSubPageId: context.page?.subPageId,
                                frameContext: context.page?.frameContext
                            });
                        });
                    }, 1000);
                    
                }).catch((error) => {
                    console.error('❌ Teams SDK navigation failed:', error);
                    console.log('🔄 FALLBACK: Using React Router navigation');
                    navigate(`/video-detail?videoId=${videoId}&vId=${categoryId}&from=home`);
                });
            } else {
                console.error('❌ Teams SDK v2 pages capability not available');
                console.log('🔄 FALLBACK: Using React Router navigation');
                navigate(`/video-detail?videoId=${videoId}&vId=${categoryId}&from=home`);
            }
        } catch (error) {
            console.error('❌ Video navigation failed:', error);
            console.log('🔄 FALLBACK: Using React Router navigation');
            navigate(`/video-detail?videoId=${videoId}&vId=${categoryId}&from=home`);
        }
    };

    const handleBlogClick = (data) => {
        const blogId = data?.id;

        const context = encodeURIComponent(
            JSON.stringify({ subEntityId: `blogId=${blogId}` })
        );

        const deepLink = `${blogDeepLink}?context=${context}`;

        console.log('📜 BLOG CLICK: Using Teams SDK v2 pages.navigateToApp');
        try {
            if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                // Teams SDK v2 method - pages.navigateToApp
                const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                const navPromise = window.microsoftTeams.pages.navigateToApp({
                    appId: teamsAppId,
                    pageId: '4d966a71-d2ea-4467-978d-9376373fa318', // BLOG_ENTITY_ID
                    subPageId: `blogId=${blogId}`
                });
                navPromise.then(() => {
                    console.log('✅ Blog navigation successful');
                }).catch((error) => {
                    console.error('❌ Blog navigation failed:', error);
                });
            } else {
                console.error('❌ Teams SDK v2 pages capability not available');
            }
        } catch (error) {
            console.error('❌ Blog navigation failed:', error);
        }
    };



    const handleNavigate = (id, categoryId) => {
        // Use handleVideoClick for consistent direct navigation behavior
        console.log('🎬 Navigating to video detail via handleVideoClick:', { id, categoryId });
        
        if (!id || !categoryId) {
            console.error('❌ Home: Missing required parameters for navigation:', { id, categoryId });
            return;
        }
        
        handleVideoClick({ id, categoryId });
    };

    const handleBlogNavigate = (blogId) => {
        if (userToken) {
            const data = { id: blogId };
            handleBlogClick(data);
        } else {
            // Add from=home parameter to track navigation origin
            navigate(`/blog-detail?blogId=${blogId}&from=home`);
        }
    };

    const handleBackClick = () => {
        console.log('🔙 BACK BUTTON: Debugging Teams SDK v2.24 availability');
        
        // Debug what's actually available
        console.log('window.microsoftTeams exists:', !!window.microsoftTeams);
        if (window.microsoftTeams) {
            console.log('Available Teams SDK properties:', Object.keys(window.microsoftTeams));
            console.log('Teams SDK version:', window.microsoftTeams.version || 'No version info');
            
            // Check different ways to access pages
            console.log('microsoftTeams.pages exists:', !!window.microsoftTeams.pages);
            console.log('microsoftTeams.app exists:', !!window.microsoftTeams.app);
            
            if (window.microsoftTeams.pages) {
                console.log('pages object methods:', Object.keys(window.microsoftTeams.pages));
                console.log('pages.isSupported type:', typeof window.microsoftTeams.pages.isSupported);
                console.log('pages.navigateToApp type:', typeof window.microsoftTeams.pages.navigateToApp);
                
                // Try to check if pages is supported
                try {
                    const isSupported = window.microsoftTeams.pages.isSupported();
                    console.log('pages.isSupported() result:', isSupported);
                } catch (e) {
                    console.log('pages.isSupported() error:', e);
                }
            } else {
                console.log('❌ pages object does not exist');
            }
        }
        
        // Try the navigation
        try {
            if (window.microsoftTeams?.pages?.isSupported?.()) {
                const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                console.log('Attempting navigation with appId:', teamsAppId);
                
                const navigationParams = {
                    appId: teamsAppId,
                    pageId: 'index'
                };
                console.log('Navigation params:', navigationParams);
                
                const navPromise = window.microsoftTeams.pages.navigateToApp(navigationParams);
                navPromise.then(() => {
                    console.log('✅ Home navigation successful');
                }).catch((error) => {
                    console.error('❌ Home navigation failed:', error);
                });
            } else {
                console.error('❌ Teams SDK v2 pages capability not supported or not available');
            }
        } catch (error) {
            console.error('❌ Navigation attempt failed:', error);
        }
    };



    const fetchSavedIntrests = async () => {

        try {
            const response = await getSavedKeywordsApi(userToken);
            setBottomList(response?.data)
            if (response?.isSuccess) {
                const ids = response?.data?.map((key) => key?.id)
                if (initial === true) {
                    await fetchAllBlogs1(ids)
                    await fetchVideosWithInterests(ids)
                }

                setSaveKeywords(response);

            }
            else {
                if (initial === true) {
                    await fetchAllBlogs()
                    await fetchVideosWithoutInterests()
                }
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }

        } finally {
            setInitial(false)
        }
    }

    const handleSaveKeywords = async (kyId) => {
        try {

            const response = await postSaveKeywordsApi(kyId, userToken);
            if (response?.isSuccess) {
                fetchSavedIntrests()

            }
            else {
                          }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }

        } finally {
            fetchVideosWithoutInterests();
            fetchAllBlogs();
        }
    }


    const handleShowModel = () => {
        setKeyWords((prevKeywords) => {
            const updatedKeywords = { ...prevKeywords };

            Object.keys(updatedKeywords).forEach((letter) => {
                updatedKeywords[letter] = updatedKeywords[letter].filter(
                    (item) => !bottomList.some((bottomItem) => bottomItem.id === item.id)
                );
            });

            return updatedKeywords;
        });

        setShowModel((prev) => !prev);
    };


    const fetchKeyWords = async () => {
        try {
            const response = await getkeyWordsApi(searchKeyword);
            if (response?.isSuccess) {
                const groupedKeywords = response?.data?.reduce((acc, key) => {
                    const firstLetter = key?.name?.charAt(0)?.toUpperCase();
                    if (!acc[firstLetter]) {
                        acc[firstLetter] = [];
                    }
                    acc[firstLetter].push({
                        id: key?.id,
                        name: key?.name
                    });
                    return acc;
                }, {});

                setKeyWords(groupedKeywords)
            }
            else {
                //  message.error(response?.message)

            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
            //   message.error(error?.response?.data?.message)

        }
    }

    const handleClose = async () => {

        await fetchKeyWords();
        await fetchSavedIntrests();
        setShowModel(false)


    }




    const handleSave = async () => {
        const ids = bottomList.map((key) => key?.id);
        setKeyIds(ids);
        setShowCategories(true);
        setDisableAllCategory(false);
        handleSaveKeywords(ids);
        setShowModel(false);
    };

    const handleRemoveSavedIntrest = (removedIntrest) => {

        const firstLetter = removedIntrest.name.charAt(0).toUpperCase();


        setBottomList((prevBottomList) =>
            prevBottomList.filter((item) => item.id !== removedIntrest.id)
        );

        setKeyWords((prevKeywords) => ({
            ...prevKeywords,
            [firstLetter]: prevKeywords[firstLetter] ? [...prevKeywords[firstLetter], removedIntrest] : [removedIntrest]
        }));

    };


    const handleBottom = (key, letter) => {


        setKeyWords((prevKeywords) => {
            if (!prevKeywords[letter]) return prevKeywords;

            return {
                ...prevKeywords,
                [letter]: prevKeywords[letter].filter(item => item.id !== key.id)
            };
        });

        setBottomList((prev) => {
            if (prev.some(item => item.id === key.id)) return prev;
            return [...prev, key];
        });
    };



    useEffect(() => {
        if (!bottomList?.length) return;

        const ids = bottomList.map(item => item?.id).filter(Boolean);
        setKeyIds(ids);
    }, [bottomList]);






    // Listen for tab reset when navigating back from video detail
    useEffect(() => {
        if (location.state?.resetTab) {
            setSwipping(1);
            // Clear the state to prevent repeated resets
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    useEffect(() => {
        // 🔧 FIXED: Wait for userToken but don't block on loading states
        if (!userToken) {
            return;
        }

        // Prevent duplicate execution - only run once on mount
        let isMounted = true;

        const loadAllData = async () => {
            if (!isMounted) return;

            try {
                await Promise.all([
                    makeUniqueRequest('home-content', fetchHomeContent),
                    makeUniqueRequest('saved-interests', fetchSavedIntrests), 
                    makeUniqueRequest('profile-pic', () => fetchProfilePic(userToken)),
                    makeUniqueRequest('categories', fetchAllCategories),
                    makeUniqueRequest('keywords', fetchKeyWords),
                ]);
            } catch (error) {
                // Handle loading error silently
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        loadAllData();

        return () => {
            isMounted = false;
        };
    }, [userToken]); // 🔧 FIXED: Only wait for userToken, not loading states

    useEffect(() => {
        // Only fetch when component first mounts or when search/category actually changes
        if (initial) return; // Skip during initial load
        
        const shouldFetch = selectedCatgId || searchValue;
        if (shouldFetch) {
            fetchCategoryVideos();
            fetchListVideos();
            fetchAllBlogs();
        }

        if (!showModel && savedKeywords?.data) {
            setPreviousData(savedKeywords.data);
        }
    }, [selectedCatgId, searchValue]); // Removed showModel and savedKeywords?.data dependencies

    useEffect(() => {
        const preventCtrlA = (e) => {
            if (e.ctrlKey && e.key === "a") {
                e.preventDefault();
            }
        };

        document.addEventListener("keydown", preventCtrlA);
        return () => document.removeEventListener("keydown", preventCtrlA);
    }, []);



    if (loading) {
        return <Loader />
    }


    return (

        <>
            <div style={{ minHeight: "100vh" }}>

                <div className="">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="whole-div">

                                <div className="row page-content">
                                    <div className="col-12">
                                        <div className="d-sm-flex align-items-center justify-content-between">
                                            <h4 className="mb-sm-0 text-white">{t('home.welcomeBack', { name: userName.split(' ')[0] })}</h4>
                                            <form className="app-search d-md-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t('home.search')}
                                                        // value={searchValue}
                                                        autoComplete="off"
                                                        id="search-options"
                                                        value={searchInput}
                                                        onChange={handleSearch1}
                                                        onKeyDown={handleKeyDown}
                                                    />
                                                    <span className="mdi mdi-magnify search-widget-icon"></span>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className="row dash-nft">
                                    <div className="col-xl-3 col-md-6">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm flex-shrink-0">
                                                        <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                                                            {loader ? (
                                                                <div 
                                                                    className="rounded-circle d-flex align-items-center justify-content-center"
                                                                    style={{
                                                                        height: "90px",
                                                                        width: "90px",
                                                                        backgroundColor: "#f0f0f0",
                                                                        border: "2px solid #ddd"
                                                                    }}
                                                                >
                                                                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                                        <span className="visually-hidden">Uploading...</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={profilePic || user}
                                                                    alt="user-profile"
                                                                    className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                                                    style={{
                                                                        height: "90px",
                                                                        width: "90px",
                                                                    }}
                                                                />
                                                            )}

                                                            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                                                <input
                                                                    id="profile-img-file-input"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="profile-img-file-input"
                                                                    onChange={handleFileChange}
                                                                />
                                                                <label
                                                                    htmlFor="profile-img-file-input"
                                                                    className="profile-photo-edit avatar-xs"
                                                                    onClick={() => console.log('🖱️ Profile edit label clicked')}
                                                                >

                                                                    <span className="avatar-title rounded-circle bg-light text-body">

                                                                        <i className="ri-pencil-line"></i>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ps-3">
                                                        <h2 className="member-name">{userName}</h2>
                                                    </div>
                                                </div>
                                                <div className="mt-4 pt-1">
                                                    <div className="d-flex gap-2 align-items-baseline" >
                                                        <Link to="/book-mark" >
                                                            <img src={bookmark} alt="icon" />
                                                        </Link>
                                                        <div>
                                                            <Link to="/book-mark">
                                                                <p className="fs-15 fw-semibold ff-secondary mb-0">
                                                                    {t('home.inProgress')}
                                                                </p>
                                                                <p>{t('home.pickupWhereLeftOff')}</p>
                                                            </Link>
                                                        </div>

                                                    </div>

                                                    <div className="d-flex gap-2 align-items-baseline">
                                                        <Link to="/book-mark" >
                                                            <img src={bookmark} alt="icon" />

                                                        </Link>
                                                        <div>
                                                            <Link to="/book-mark" >
                                                                <p className="fs-15 fw-semibold ff-secondary mb-0">
                                                                    {t('home.bookmarkedItems')}
                                                                </p>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card hieght-100vh stick-div">
                                            <div className="card-body">
                                                <div className="d-flex gap-2 pt-2 mainheading-point">
                                                    <div className="w-100 d-flex justify-content-between align-items-center mainhhead">
                                                        <h5 className="card-title mb-1">
                                                            {t('home.saveYourInterests')} <br />

                                                        </h5>
                                                    </div>
                                                </div>
                                                <div className="pt-1">
                                                    <div className="d-flex flex-wrap align-items-baseline save-int">
                                                        {/* Show loading state while interests are being fetched */}
                                                        {loading ? (
                                                            <div className="d-flex gap-2">
                                                                <div className="br-div" style={{ background: '#f0f0f0', color: '#999' }}>Loading...</div>
                                                            </div>
                                                        ) : (
                                                            (showModel ? previousData : savedKeywords?.data)?.map((key, index) => {
                                                                const colors = [
                                                                    { textColor: "#ffa008", backgroundColor: "#fff5e6" },
                                                                    { textColor: "#007bff", backgroundColor: "#e6f7ff" },
                                                                    { textColor: "#28a745", backgroundColor: "#e6ffe6" },
                                                                ];

                                                                const colorIndex = index % colors.length; // This will alternate the colors

                                                                return (
                                                                    <p
                                                                        className="br-div"
                                                                        style={{
                                                                            color: colors[colorIndex].textColor,
                                                                            background: colors[colorIndex].backgroundColor,
                                                                        }}
                                                                        key={index}
                                                                    >

                                                                        {dbLabel(key.name, i18n.language)}
                                                                    </p>
                                                                );
                                                            })
                                                        )}

                                                        <p className="br-div" style={{ color: "#00273a", background: "#f3f9e7", cursor: "pointer" }} >
                                                            <a data-bs-toggle="modal" data-bs-target=".bs-example-modal-center-top" onClick={handleShowModel}>
                                                                <img src={editicon} alt="edit" /> {t('home.edit')}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-9">
                                        <div className="card overflow-hidden">
                                            <div className="d-flex align-items-center gap-3 port-2">
                                                <div className="portfolio-card">
                                                    <img src={homepng} alt="portfolio" />
                                                </div>
                                                <div className="content-area small-size">
                                                    <h1>
                                                        {t('home.heroTitle1')} <br />
                                                        {t('home.heroTitle2')}
                                                    </h1>

                                                    <p className="mb-0 mt-2 pt-1">
                                                        {/* API intro copy exists in English only; FR/NL use locale text (home.heroText). */}
                                                        {i18n.language === 'en' ? (
                                                            <div dangerouslySetInnerHTML={{
                                                                __html: sanitize(title && title[0] && title[0].content ? title[0].content : 'Healthier worklife starts here.')
                                                            }}></div>
                                                        ) : (
                                                            <div>{t('home.heroText')}</div>
                                                        )}
                                                    </p>
                                                    <div className="readmore-btn">
                                                        {/* Prevent layout jump by reserving space for button */}
                                                        <h5 className="mt-5" style={{ minHeight: '32px' }}>
                                                             <a className="cursor-pointer" onClick={() => {
                                                                 console.log('🎯 BLOG NAVIGATION: Home -> Blog Library (cross-tab)');
                                                                 
                                                                 // Use Teams SDK to navigate to Blog Library tab
                                                                 if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                                                                     const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                                                                     
                                                                     window.microsoftTeams.pages.navigateToApp({
                                                                         appId: teamsAppId,
                                                                         pageId: '4d966a71-d2ea-4467-978d-9376373fa318' // Blog Library entity ID
                                                                     }).then(() => {
                                                                         console.log('✅ Successfully navigated to Blog Library tab');
                                                                     }).catch(error => {
                                                                         console.error('❌ Blog Library navigation failed:', error);
                                                                     });
                                                                 } else {
                                                                     console.error('❌ Teams SDK pages navigation not available');
                                                                     // Fallback to React Router if Teams SDK not available
                                                                     navigate('/blog-library?from=index&entityId=blog-library');
                                                                 }
                                                                 
                                                                 console.log('🔄 Cross-tab navigation: Home tab -> Blog Library tab');
                                                             }}>{t('home.checkLatestBlogs')}</a>
                                                        </h5>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-body bg-marketplace align-items-center">
                                                <div className="d-flex align-items-center gap-2 pb-4 left-heading">
                                                    <div className="w-100 flex-wrap d-flex justify-content-between align-items-center">
                                                        <h5 className="card-title mb-1">{t('home.getStartedQuickVideo')}</h5>
                                                        {/* ARROWS POSITIONED CORRECTLY NEXT TO HEADING */}
                                                        <div className="d-flex gap-2" style={{ marginRight: '15px' }}>
                                                            <button 
                                                                className="custom-nav-prev"
                                                                style={{
                                                                    background: '#2c3e50',
                                                                    border: 'none',
                                                                    padding: '6px',
                                                                    borderRadius: '50%',
                                                                    width: '32px',
                                                                    height: '32px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                    <polyline points="15,18 9,12 15,6"></polyline>
                                                                </svg>
                                                            </button>
                                                            <button 
                                                                className="custom-nav-next"
                                                                style={{
                                                                    background: '#2c3e50',
                                                                    border: 'none',
                                                                    padding: '6px',
                                                                    borderRadius: '50%',
                                                                    width: '32px',
                                                                    height: '32px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                    <polyline points="9,18 15,12 9,6"></polyline>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="swiper marketplace-swiper rounded gallery-light">
                                                    <div className="swiper-wrapper">


                        {(categoryLoading || listLoading || showSkeleton) ? (
                            <div className="d-flex" style={{ gap: '15px', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                                {/* Show 3 carousel-specific video skeleton cards */}
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} style={{ flex: '0 0 auto', width: 'calc(33.333% - 10px)' }}>
                                        <SkeletonCarouselVideoCard />
                                    </div>
                                ))}
                            </div>
                        ) : (
                                                            getAllVideos?.data?.videos?.length > 0 && (
                                                                <OwlCarousel
                                                                    key={`home-videos-working-${getAllVideos?.data?.videos?.length || 0}`}
                                                                    dots={false}
                                                                    autoplay={true}
                                                                    autoplayTimeout={3000}
                                                                    rewind={true}
                                                                    loop={getAllVideos?.data?.videos?.length > 3}
                                                                    responsiveClass={true}
                                                                    smartSpeed={800}
                                                                    nav={false}
                                                                    margin={15}
                                                                    mouseDrag={true}
                                                                    touchDrag={true}
                                                                    responsive={{
                                                                        0: { items: 1 },
                                                                        600: { items: 2 },
                                                                        1024: { items: 3 },
                                                                        1366: { items: 3 },
                                                                    }}
                                                                    ref={(carousel) => {
                                                                        if (carousel) {
                                                                            // Use setTimeout to ensure DOM elements are available
                                                                            setTimeout(() => {
                                                                                const prevBtn = document.querySelector('.custom-nav-prev');
                                                                                const nextBtn = document.querySelector('.custom-nav-next');
                                                                                if (prevBtn && nextBtn) {
                                                                                    prevBtn.onclick = () => {
                                                                                        try {
                                                                                            carousel.prev();
                                                                                        } catch (error) {
                                                                                            console.warn('Main carousel prev navigation failed:', error);
                                                                                        }
                                                                                    };
                                                                                    nextBtn.onclick = () => {
                                                                                        try {
                                                                                            carousel.next();
                                                                                        } catch (error) {
                                                                                            console.warn('Main carousel next navigation failed:', error);
                                                                                        }
                                                                                    };
                                                                                    console.log('✅ Main navigation buttons connected');
                                                                                } else {
                                                                                    console.warn('⚠️ Main navigation buttons not found');
                                                                                }
                                                                            }, 100);
                                                                        }
                                                                    }}
                                                                >
                                                                    {getAllVideos?.data?.videos?.length > 0 && (
                                                                        getAllVideos?.data?.videos?.map((slide, index) => (



                                                                            <div className="item" key={index} >

                                                                                <div className="card explore-box card-animate">
                                                                                    <div className="explore-place-bid-img" onClick={() => handleNavigate(slide?.id, slide?.category?.id)}>
                                                                                        <img
                                                                                            src={slide?.thumbnail}
                                                                                            alt={slide.title}
                                                                                            className="img-fluid card-img-top explore-img"
                                                                                            style={{ height: "200px", objectFit: "cover" }}
                                                                                        />
                                                                                        <div className="bg-overlay"></div>
                                                                                        <div className="place-bid-btn">
                                                                                            <a className="cursor-pointer">
                                                                                                <i className="ri-play-circle-fill align-bottom me-1"></i>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="card-body">
                                                                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                            <h6 className="card-title mb-0 flex-grow-1" 
                                                                                                style={{ 
                                                                                                    cursor: "pointer", 
                                                                                                    fontSize: "14px",
                                                                                                    lineHeight: "1.2",
                                                                                                    height: "17px",
                                                                                                    overflow: "hidden",
                                                                                                    whiteSpace: "nowrap",
                                                                                                    textOverflow: "ellipsis"
                                                                                                }} 
                                                                                                onClick={() => handleNavigate(slide?.id, slide?.category?.id)}>
                                                                                                <a className="text-primary">
                                                                                                    {slide?.title}
                                                                                                </a>
                                                                                            </h6>
                                                                                            <button
                                                                                                className="btn btn-sm p-0"
                                                                                                onClick={() => {
                                                                                                    console.log('📌 DEBUG: Bookmark icon click - Current state:', {
                                                                                                        slideId: slide?.id,
                                                                                                        isBookmarked: BookMarkedTrueIds.includes(slide?.id),
                                                                                                        allBookmarkedIds: BookMarkedTrueIds
                                                                                                    });
                                                                                                    handleAddBookMark(slide?.id);
                                                                                                }}
                                                                                                disabled={bookmarkLoadingIds.includes(slide?.id)}
                                                                                                style={{ background: "none", border: "none" }}
                                                                                            >


                                                                                            <i className={`mdi ${BookMarkedTrueIds.includes(slide?.id) ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18`} 
                                                                                               style={{ 
                                                                                                   color: BookMarkedTrueIds.includes(slide?.id) ? '#16f69f' : '#6c757d',
                                                                                                   fontSize: '18px'
                                                                                               }}></i>
                                                                                            </button>
                                                                                        </div>
                                                                                        {slide?.subCategory?.name && (
                                                                                            <p className="text-muted mb-1">
                                                                                                <small>{dbLabel(slide.subCategory.name, i18n.language)}</small>
                                                                                            </p>
                                                                                        )}
                                                                                        {slide?.duration && (
                                                                                            <p className="text-muted mb-0">
                                                                                                <small><i className="ri-time-line me-1"></i>{slide.duration}</small>
                                                                                            </p>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    )}
                                                                </OwlCarousel>

                                                            )


                                                            // )


                                                        )}
                                                    </div>
                                                </div>

                                                {
                                                    videos?.data?.count === 0 && (
                                                        <div className="d-flex justify-content-center w-100 h-100">
                                                            <div className="text-center" style={{ maxWidth: '400px' }}>
                                                                <h5 className="text-gray-500 mb-3">{t('common.noVideos')}</h5>
                                                                <p className="text-gray-400 small">{t('common.technicalDifficulties')}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                }




                                                {(disableAllCategory && !showCategories) ? (
                                                    <></>
                                                ) : (
                                                    <>


                                                        <ul className="nav nav-tabs navlist mt-3 mb-3 align-items-center" role="tablist">
                                                            <p className="mb-0">{t('home.browseBy')}</p>
                                                            <li className="nav-item" onClick={(e) => { handleSetSwipping(1) }}>
                                                                <a className="nav-link " style={{ color: swipping === 1 ? "#16f69f" : "black", cursor: "pointer" }} role="tab">
                                                                    {t('home.tabVideos')}
                                                                </a>
                                                            </li>
                                                            <li className="nav-item" onClick={(e) => { handleSetSwipping(2) }} >
                                                                <a className="nav-link  new-div" style={{ color: swipping === 2 ? "#16f69f" : "black", cursor: "pointer" }} role="tab">
                                                                    {t('home.tabDuration')}
                                                                </a>
                                                            </li>
                                                            <li className="nav-item" onClick={(e) => { handleSetSwipping(3) }} >
                                                                <a className="nav-link  new-div" style={{ color: swipping === 3 ? "#16f69f" : "black", cursor: "pointer" }} role="tab">
                                                                    {t('home.tabBlogs')}
                                                                </a>
                                                            </li>
                                                        </ul>



                                                        <div className="tab-content text-muted">
                                                            {swipping == 1 && (

                                                                <div style={{ display: swipping === 1 ? "block" : "" }}>
                                                                    <div className="col-lg-12">

                                                                        <div>
                                                                            {filteredVideos &&
                                                                                Object.entries(filteredVideos)
                                                                                    .filter(([_, subcategories]) =>
                                                                                        Object.values(subcategories).some((videos) => videos.length > 0)
                                                                                    )
                                                                                    .map(([category, subcategories]) => (
                                                                                        <div className="live-preview" key={category}>
                                                                                            <div className="lefticon-accordion custom-accordionwithicon accordion-border-box" id="accordionlefticon">
                                                                                                <div className="accordion-item colle-slider">

                                                                                                    <h2 className="accordion-header d-flex align-items-center" id={`accordion-${category}`}>
                                                                                                        <button
                                                                                                            className={`accordion-button fw-semibold ${activeAccordions.includes(category) ? "" : "collapsed"}`}
                                                                                                            type="button"
                                                                                                            onClick={() => toggleAccordion(category)}
                                                                        >
                                                                            {dbLabel(category, i18n.language)}
                                                                                                        </button>
                                                                                                    </h2>

                                                                                                    <div
                                                                                                        id={`collapse-${category}`}
                                                                                                        className={`accordion-collapse fw-semibold ${activeAccordions.includes(category) ? "show" : "collapse"}`}
                                                                                                        aria-labelledby={`accordion-${category}`}
                                                                                                    >

                                                                                                        {Object.entries(subcategories)
                                                                                                            .filter(([_, videos]) => videos.length > 0)
                                                                                                            .map(([subcategory, videos]) => (
                                                                                                                <div key={subcategory} style={{ marginLeft: '1%' }}>
                                                                                                                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                                                                                                                        <a
                                                                                                                            className={`accordion-button fw-semibold ${activeSubcategories[category] === subcategory ? "" : "collapsed"}`}
                                                                                                                            style={{
                                                                                                                                color: "black",
                                                                                                                                cursor: "pointer",
                                                                                                                                flex: 1,
                                                                                                                                background: "none",
                                                                                                                                border: "none",
                                                                                                                                padding: "8px 0",
                                                                                                                                textDecoration: "none",
                                                                                                                                position: "relative"
                                                                                                                            }}
                                                                                                                            role="tab"
                                                                                                                            onClick={() => toggleSubcategory(category, subcategory)}
                                                                                                                        >
                                                                                                                            {dbLabel(subcategory, i18n.language)}
                                                                                                                        </a>
                                                                                                                        {/* ARROWS ONLY SHOW WHEN SUBCATEGORY IS EXPANDED */}
                                                                                                                        {activeSubcategories[category] === subcategory && (
                                                                                                                            <div className="d-flex gap-2" style={{ marginRight: '15px' }}>
                                                                                                                                <button 
                                                                                                                                    className={`custom-nav-prev-videos-${category.replace(/\s+/g, '-')}-${subcategory.replace(/\s+/g, '-')}`}
                                                                                                                                    style={{
                                                                                                                                        background: '#2c3e50',
                                                                                                                                        border: 'none',
                                                                                                                                        padding: '6px',
                                                                                                                                        borderRadius: '50%',
                                                                                                                                        width: '32px',
                                                                                                                                        height: '32px',
                                                                                                                                        display: 'flex',
                                                                                                                                        alignItems: 'center',
                                                                                                                                        justifyContent: 'center',
                                                                                                                                        cursor: 'pointer'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                                         <polyline points="15,18 9,12 15,6"></polyline>
                                                                                                                                     </svg>
                                                                                                                                </button>

                                                                                                                                <button 
                                                                                                                                    className={`custom-nav-next-videos-${category.replace(/\s+/g, '-')}-${subcategory.replace(/\s+/g, '-')}`}
                                                                                                                                    style={{
                                                                                                                                        background: '#2c3e50',
                                                                                                                                        border: 'none',
                                                                                                                                        padding: '6px',
                                                                                                                                        borderRadius: '50%',
                                                                                                                                        width: '32px',
                                                                                                                                        height: '32px',
                                                                                                                                        display: 'flex',
                                                                                                                                        alignItems: 'center',
                                                                                                                                        justifyContent: 'center',
                                                                                                                                        cursor: 'pointer'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                                         <polyline points="9,18 15,12 9,6"></polyline>
                                                                                                                                     </svg>
                                                                                                                                </button>

                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </div>

                                                                                                                    {activeSubcategories[category] === subcategory && (
                                                                                                                         <Swipper 
                                                                                                                             data={videos} 
                                                                                                                             fetchAllVideos={fetchVideosWithoutInterests} 
                                                                                                                             fetchVideos={fetchCategoryVideos}
                                                                                                                             navPrevClass={`custom-nav-prev-videos-${category.replace(/\s+/g, '-')}-${subcategory.replace(/\s+/g, '-')}`}
                                                                                                                             navNextClass={`custom-nav-next-videos-${category.replace(/\s+/g, '-')}-${subcategory.replace(/\s+/g, '-')}`}
                                                                                                                         />
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            ))}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}



                                                                            {videos?.data?.count === 0 && (
                                                                                <div className="d-flex justify-content-center">
                                                                                    <div className="text-center" style={{ maxWidth: '400px' }}>
                                                                                        <h5 className="text-gray-500 mb-3">{t('common.noVideos')}</h5>
                                                                                        <p className="text-gray-400 small">{t('common.technicalDifficulties')}</p>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            }

                                                            {swipping == 2 && (
                                                                <div style={{ display: swipping === 2 ? "block" : "" }}>
                                                                    <div className="lefticon-accordion custom-accordionwithicon accordion-border-box">
                                                                        <div>
                                                                            {videos?.data?.durationWise &&
                                                                                Object.entries(videos.data.durationWise)
                                                                                    .filter(([_, slides]) => slides.length > 0)
                                                                                    .map(([duration, slides]) => (
                                                                                        <div className="accordion-item colle-slider" key={duration}>
                                                                                            <h2 className="accordion-header" style={{ marginBottom: "2%" }} id={`accordion-duration-${duration}`}>
                                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                                    <button
                                                                                                        className={`accordion-button fw-semibold ${activeDurationAccordions.includes(duration) ? "" : "collapsed"}`}
                                                                                                        type="button"
                                                                                                        onClick={() => {
                                                                                                            toggleDurationAccordion(duration);
                                                                                                            setTimeout(() => {
                                                                                                                if (window.microsoftTeams) {
                                                                                                                    try {
                                                                                                                        if (window.microsoftTeams?.app?.initialize && window.microsoftTeams?.app?.setFrameContext) {
                                                                                                                            window.microsoftTeams.app.initialize().then(() => {
                                                                                                                                window.microsoftTeams.app.setFrameContext({
                                                                                                                                    height: document.body.scrollHeight,
                                                                                                                                });
                                                                                                                            }).catch(e => console.log('Teams SDK error:', e));
                                                                                                                        }
                                                                                                                    } catch (e) {
                                                                                                                        console.log('Teams initialization error:', e);
                                                                                                                    }
                                                                                                                }
                                                                                                            }, 300);
                                                                                                        }}
                                                                                                        style={{ flex: 1 }}
                                                                                                    >
                                                                                                        {duration}
                                                                                                    </button>
                                                                                                    {/* ARROWS ONLY SHOW WHEN DURATION SECTION IS EXPANDED - FIXED POSITIONING */}
                                                                                                    {activeDurationAccordions.includes(duration) && (
                                                                                                        <div className="d-flex gap-2" style={{ marginRight: '15px' }}>
                                                                                                            <button 
                                                                                                                className={`custom-nav-prev-duration-${duration.replace(/\s+/g, '-')}`}
                                                                                                                style={{
                                                                                                                    background: '#2c3e50',
                                                                                                                    border: 'none',
                                                                                                                    padding: '6px',
                                                                                                                    borderRadius: '50%',
                                                                                                                    width: '32px',
                                                                                                                    height: '32px',
                                                                                                                    display: 'flex',
                                                                                                                    alignItems: 'center',
                                                                                                                    justifyContent: 'center',
                                                                                                                    cursor: 'pointer'
                                                                                                                }}
                                                                                                            >
                                                                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                    <polyline points="15,18 9,12 15,6"></polyline>
                                                                                                                </svg>
                                                                                                            </button>
                                                                                                            <button 
                                                                                                                className={`custom-nav-next-duration-${duration.replace(/\s+/g, '-')}`}
                                                                                                                style={{
                                                                                                                    background: '#2c3e50',
                                                                                                                    border: 'none',
                                                                                                                    padding: '6px',
                                                                                                                    borderRadius: '50%',
                                                                                                                    width: '32px',
                                                                                                                    height: '32px',
                                                                                                                    display: 'flex',
                                                                                                                    alignItems: 'center',
                                                                                                                    justifyContent: 'center',
                                                                                                                    cursor: 'pointer'
                                                                                                                }}
                                                                                                            >
                                                                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                    <polyline points="9,18 15,12 9,6"></polyline>
                                                                                                                </svg>
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </h2>

                                                                                            <div
                                                                                                id={`collapse-duration-${duration}`}
                                                                                                className={`accordion-collapse collapse ${activeDurationAccordions.includes(duration) ? "show" : ""}`}
                                                                                                aria-labelledby={`accordion-duration-${duration}`}
                                                                                            >
                                                                                                <div className="accordion-body swiper collection-slider rounded gallery-light">
                                                                                                    <div className="swiper-wrapper">
                                                                                                        <Swipper
                                                                                                            data={slides}
                                                                                                            fetchAllVideos={fetchVideosWithoutInterests}
                                                                                                            fetchVideos={fetchCategoryVideos}
                                                                                                            navPrevClass={`custom-nav-prev-duration-${duration.replace(/\s+/g, '-')}`}
                                                                                                            navNextClass={`custom-nav-next-duration-${duration.replace(/\s+/g, '-')}`}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}

                                                                            {videos?.data?.count === 0 && (
                                                                                <div className="d-flex justify-content-center">
                                                                                    <div className="text-center" style={{ maxWidth: '400px' }}>
                                                                                        <h5 className="text-gray-500 mb-3">{t('common.noVideos')}</h5>
                                                                                        <p className="text-gray-400 small">{t('common.technicalDifficulties')}</p>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}



                                                            {swipping === 3 && (
                                                                (
                                                                    <div style={{ display: swipping === 3 ? "block" : "" }}>
                                                                        <div className="col-lg-12">
                                                                            <div>
                                                                                {filterBlogs?.data?.categoryWise &&
                                                                                    Object.entries(filterBlogs?.data?.categoryWise)
                                                                                        .filter(([_, slides]) => slides?.length > 0)
                                                                                        .map(([category, slides]) => (
                                                                                            <div className="live-preview" key={category} >
                                                                                                <div
                                                                                                    className="lefticon-accordion custom-accordionwithicon accordion-border-box"
                                                                                                    id="accordionlefticon"
                                                                                                >

                                                                    {/* 🔧 DEBUG: Log carousel data for navigation debugging */}

                                                                                                    <div className="accordion-item colle-slider">
                                                                                                        <h2 className="accordion-header" style={{ marginBottom: "2%" }} id={`accordion-blog-${category}`}>
                                                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                                                <button
                                                                                                                    className={`accordion-button fw-semibold ${activeBlogAccordions.includes(category) ? "" : "collapsed"}`}
                                                                                                                    type="button"
                                                                                                                    onClick={() => {
                                                                                                                        toggleBlogAccordion(category);
                                                                                                                        setTimeout(() => {
                                                                                                                            if (window.microsoftTeams) {
                                                                                                                                try {
                                                                                                                                    if (window.microsoftTeams?.app?.initialize && window.microsoftTeams?.app?.setFrameContext) {
                                                                                                                                        window.microsoftTeams.app.initialize().then(() => {
                                                                                                                                            window.microsoftTeams.app.setFrameContext({
                                                                                                                                                height: document.body.scrollHeight,
                                                                                                                                            });
                                                                                                                                        }).catch(e => console.log('Teams SDK error:', e));
                                                                                                                                    }
                                                                                                                                } catch (e) {
                                                                                                                                    console.log('Teams initialization error:', e);
                                                                                                                                }
                                                                                                                            }
                                                                                                                        }, 300);
                                                                                                                    }}
                                                                                                                    style={{ flex: 1 }}
                                                                                                                >
                                                                                                                    {dbLabel(category, i18n.language)}
                                                                                                                </button>

                                                                                                                {/* ARROWS FOR BLOGS TAB */}
                                                                                                                {/* ARROWS ONLY SHOW WHEN BLOG SECTION IS EXPANDED - FIXED POSITIONING */}
                                                                                                                {activeBlogAccordions.includes(category) && (
                                                                                                                    <div className="d-flex gap-2" style={{ marginRight: '15px' }}>
                                                                                                                    <button 
                                                                                                                        className={`custom-nav-prev-blog-${category.replace(/\s+/g, '-')}`}
                                                                                                                        style={{
                                                                                                                            background: '#2c3e50',
                                                                                                                            border: 'none',
                                                                                                                            padding: '6px',
                                                                                                                            borderRadius: '50%',
                                                                                                                            width: '32px',
                                                                                                                            height: '32px',
                                                                                                                            display: 'flex',
                                                                                                                            alignItems: 'center',
                                                                                                                            justifyContent: 'center',
                                                                                                                            cursor: 'pointer'
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                            <polyline points="15,18 9,12 15,6"></polyline>
                                                                                                                        </svg>
                                                                                                                    </button>

                                                                                                                    <button 
                                                                                                                        className={`custom-nav-next-blog-${category.replace(/\s+/g, '-')}`}
                                                                                                                        style={{
                                                                                                                            background: '#2c3e50',
                                                                                                                            border: 'none',
                                                                                                                            padding: '6px',
                                                                                                                            borderRadius: '50%',
                                                                                                                            width: '32px',
                                                                                                                            height: '32px',
                                                                                                                            display: 'flex',
                                                                                                                            alignItems: 'center',
                                                                                                                            justifyContent: 'center',
                                                                                                                            cursor: 'pointer'
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'white' }}>
                                                                                                                            <polyline points="9,18 15,12 9,6"></polyline>
                                                                                                                        </svg>
                                                                                                                    </button>

                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </h2>
                                                                                                        <div
                                                                                                            id={`collapse-blog-${category}`}
                                                                                                            className={`accordion-collapse fw-semibold ${activeBlogAccordions.includes(category) ? "show" : "collapse"}`}
                                                                                                            aria-labelledby={`accordion-blog-${category}`}
                                                                                                        >


                                                                                                            {activeBlogAccordions.includes(category) && (
                                                                                                                <HomeBlogCarousel 
                                                                                                                    data={slides} 
                                                                                                                    fetchAllBlogs={fetchAllBlogs}
                                                                                                                    navPrevClass={`custom-nav-prev-blog-${category.replace(/\s+/g, '-')}`}
                                                                                                                    navNextClass={`custom-nav-next-blog-${category.replace(/\s+/g, '-')}`}
                                                                                                                />
                                                                                                            )}

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}


                                                                                {noBlog && (
                                                                                    <div style={{ textAlign: "center" }} className="flex justify-center items-center h-64">
                                                                                        {blogFetchError ? (
                                                                                            <>
                                                                                                <div>
                                                                                                    <h1 className="text-xl font-semibold text-gray-500">{t('home.unableToLoadBlogs')}</h1>
                                                                                                    <p className="text-gray-400 mt-2">{t('common.technicalDifficulties')}</p>
                                                                                                    <button
                                                                                                        className="btn btn-primary mt-3"
                                                                                                        onClick={() => {
                                                                                                            setBlogFetchError(false);
                                                                                                            fetchAllBlogs();
                                                                                                        }}
                                                                                                    >
                                                                                                        {t('common.tryAgain')}
                                                                                                    </button>
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (
                                                                                            <h1 className="text-xl font-semibold text-gray-500">{t('home.noBlogs')}</h1>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )

                                                            )}

                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div >

            </div >




            {showModel && (
                <div style={{ display: showModel ? "block" : "", backgroundColor: "#000000b8" }} className="modal bs-example-modal-center-top" tabIndex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header mb-3 align-items-center">
                                <h5 className="mb-0"> {t('home.pickYourInterests')}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => { setShowModel(false) }}></button>
                            </div>
                            <div className="modal-body p-3 pt-0">


                                <div className="search-bar position-relative">
                                    <input type="text" placeholder={t('home.findByName')} style={{ color: "black" }} value={searchKeyword} onChange={handleSearch} />
                                    <span className=""><i className="ri ri-search-line"></i></span>

                                </div>


                                <div className="section-title" style={{ color: "black" }}>{t('home.yourSavedInterests')}</div>
                                <div className="tags">
                                    {bottomList?.map((key, index) => {
                                        const colors = [
                                            { textColor: "#ffa008", backgroundColor: "#fff5e6" },
                                            { textColor: "#007bff", backgroundColor: "#e6f7ff" },
                                            { textColor: "#28a745", backgroundColor: "#e6ffe6" },
                                        ];

                                        const colorIndex = index % colors.length;

                                        return (
                                            <span
                                                key={index}
                                                className="tag selected"
                                                style={{
                                                    color: colors[colorIndex].textColor,
                                                    backgroundColor: colors[colorIndex].backgroundColor,
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => handleRemoveSavedIntrest(key)}
                                            >
                                                {dbLabel(key?.name, i18n.language)}
                                            </span>
                                        );
                                    })}


                                </div>


                                <div className="section-title" style={{ color: "black" }}>{t('home.selectInterests')}</div>
                                <div className="categories">

                                    {Object.keys(searchingFilter)
                                        .sort()
                                        .map((letter) => {
                                            if (searchingFilter[letter]?.length > 0) {
                                                return (
                                                    <div key={letter} className="category" style={{ cursor: "pointer" }}>
                                                        <div className="category-title" style={{ color: "black", cursor: "pointer" }}>
                                                            {letter}
                                                        </div>
                                                        <div className="category-tags">

                                                            {searchingFilter[letter].map((item) => (
                                                                <span
                                                                    key={item.id}
                                                                    className="tag"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => handleBottom(item, letter)}
                                                                >
                                                                    {dbLabel(item.name, i18n.language)}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}

                                </div>


                                <div className="actions">
                                    <button className="button cancel-button" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}>Cancel</button>
                                    <button className="button save-button " data-bs-dismiss="modal" aria-label="Close" onClick={handleSave}>Save</button>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            )}
            {/* Removed YouTube iframe that was causing permissions policy violations */}
            {/* Your videos are stored on backend server, not YouTube */}
        </>


    )
}

export default Home